"use client";

import { useState } from "react";
import { setupI18n, type Messages } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import type { Locale } from "@/lib/i18n/locales";

/**
 * Client boundary of the Lingui setup: receives the request's locale and its
 * compiled catalog from the server root layout (serializable token structure)
 * and provides i18n to client components. The locale is fixed per page load —
 * the language switcher navigates/reloads, so no live re-activation needed.
 */
export function LinguiClientProvider({
  locale,
  messages,
  children,
}: {
  locale: Locale;
  messages: Messages;
  children: React.ReactNode;
}) {
  const [i18n] = useState(() => setupI18n({ locale, messages: { [locale]: messages } }));
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
